import { createContext, useContext } from "react";

/**
 * Lets the top navigation's hamburger drive the app sidebar's mobile drawer.
 *
 * The sidebar (AppSidebar) is desktop-only — `hidden lg:block` — so below
 * 1024px every role's real navigation used to be unreachable, and Navigation
 * carried a hand-maintained partial copy of it instead. That copy always drifted
 * (a BL advisor could not reach Deal CRM, Shared Listings, Deleted Listings, the
 * advisor directory or any Settings sub-page from a phone). Now the same
 * sidebar renders as an off-canvas drawer on mobile and the hamburger opens it.
 *
 * `AppShell` provides the value; `Navigation` and `AppSidebar` consume it. The
 * context is deliberately null by default: pages with no sidebar (sellers,
 * logged-out visitors) keep Navigation's own inline menu.
 */
export type SidebarDrawer = {
  open: boolean;
  toggle: () => void;
  close: () => void;
};

export const SidebarDrawerContext = createContext<SidebarDrawer | null>(null);

export function useSidebarDrawer() {
  return useContext(SidebarDrawerContext);
}
